import React from "react";
import { Grid } from "@mui/material";
import { Alert, CheckboxField } from "@curves/ui-base";
import { FieldGroup } from "@icoach/documents/components/Layout";
import { ReadTextField } from "@icoach/components";
import { displayDateText, parseDate } from "@util/moment";
import { isEmpty, matchOptionsText } from "@util/utils";
import { useMembershipSuspensionFormContext } from "@icoach/documents/membership/suspension/MembershipSuspensionFormContext";

const MembershipSuspensionBillingSection = () => {
	const {
		formData,
		formRef,
		options,
		isReadOnly,
		handleExtensionChange,
	} = useMembershipSuspensionFormContext();

	const {
		suspensionDate,
		recoveryDate,
		paymentType,
		debitDayOfMonth,
		membershipStartDate,
		membershipEndDate,
		membershipExtensionDate,
		visibleOverNextSuspend = false,
		isKeepDebit,
	} = formData;
	const { paymentTypeOptions } = options;

	return (
		<>
			<FieldGroup label="扣款資訊">
				<Grid item xs={4}>
					{!isEmpty(paymentTypeOptions) && (
						<ReadTextField label="付款方式">{matchOptionsText(paymentTypeOptions, paymentType)}</ReadTextField>
					)}
				</Grid>
				<Grid item xs={4}>
					<ReadTextField label="每月扣款日">{`${debitDayOfMonth} 號`}</ReadTextField>
				</Grid>
				<Grid item xs={4} />
				<Grid item xs={4}>
					<ReadTextField label="暫停扣款日">{parseDate(suspensionDate, "YYYY/MM/DD")}</ReadTextField>
				</Grid>
				<Grid item xs={4}>
					<ReadTextField label="恢復扣款日">{parseDate(recoveryDate, "YYYY/MM/DD")}</ReadTextField>
				</Grid>
				<Grid item xs={4} />
				<Grid item xs={12}>
					<CheckboxField
						ref={el => (formRef.current.isKeepDebit = el)}
						defaultChecked={[!!isKeepDebit]}
						readOnly={isReadOnly}
						onChange={handleExtensionChange}
					>
						<CheckboxField.Checkbox label="此暫停申請書僅延長會籍，不執行停扣" value="isKeepDebit" />
					</CheckboxField>
				</Grid>
				{visibleOverNextSuspend && (
					<Grid item xs={8}>
						<Alert severity="info" variant="filled" color="info" className="alert-justify-content-start">
							因超過20日提出申請，暫停扣款將從次次月開始停扣
						</Alert>
					</Grid>
				)}
			</FieldGroup>

			<FieldGroup label="會籍異動">
				<Grid item xs={8}>
					<ReadTextField label="會籍期間">{displayDateText(membershipStartDate, membershipEndDate)}</ReadTextField>
				</Grid>
				<Grid item xs={8}>
					<ReadTextField label="更新後會籍">
						{displayDateText(membershipStartDate, membershipExtensionDate)}
					</ReadTextField>
				</Grid>
			</FieldGroup>
		</>
	);
};

export default MembershipSuspensionBillingSection;